export default __webpack_public_path__ + "static/news-img1-183f0d9180e927dc2e6413b023d1c1ff.png";